// Utility functions for demo mode

export const isDemoUser = (userEmail) => {
  return userEmail === 'info@sashy.ai';
};

export const getDemoBusinessSelections = () => {
  try {
    const saved = localStorage.getItem('demoBusinessSelections');
    return saved ? JSON.parse(saved) : [];
  } catch (error) {
    console.error('Error reading demo business selections:', error);
    return [];
  }
};

export const setDemoBusinessSelections = (businesses) => {
  try {
    localStorage.setItem('demoBusinessSelections', JSON.stringify(businesses));
  } catch (error) {
    console.error('Error saving demo business selections:', error);
  }
};

export const clearDemoBusinessSelections = () => {
  try {
    localStorage.removeItem('demoBusinessSelections');
  } catch (error) {
    console.error('Error clearing demo business selections:', error);
  }
}; 